import Swal from "sweetalert2";

const toast = (text, ms = 1200, icon = "success") => {
    Swal.fire({
        text,
        icon,
        width: "280px",
        timer: ms,
        showConfirmButton: false,
    });
};

const normalize = (v) => {
    if (Array.isArray(v)) return v.map(String).join(", ");
    if (v === null || v === undefined) return "";
    return String(v).trim();
};

const fallbackCopy = (text) => {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
};

const writeClipboard = async (text) => {
    const t = normalize(text);
    if (!t) return false;

    try {
        await navigator.clipboard.writeText(t);
        return true;
    } catch (e) {
        try {
            fallbackCopy(t);
            return true;
        } catch {
            return false;
        }
    }
};

export const copyField = async (value, label = "Value", ms = 1200) => {
    const v = normalize(value);

    const textToCopy = v; // label ? `${label}: ${v}` : v;
    const ok = await writeClipboard(textToCopy);

    toast(ok ? `${label} copied!` : "Copy failed", ms, ok ? "success" : "error");
    return ok;
};

export const copyAllFields = async (input, ms = 1500) => {
    let lines = [];

    // Case 1: array of {label, value}
    if (Array.isArray(input)) {
        lines = input
            .map((f) => {
                const v = normalize(f?.value);
                if (!v) return null;
                return `${f?.label}: ${v}`;
            })
            .filter(Boolean);
    } else if (input && typeof input === "object") {
        const isWalletLike =
            "accountNumber" in input ||
            "bankName" in input ||
            "accountName" in input ||
            "iban" in input ||
            "swift" in input;

        if (isWalletLike) {
            const ordered = [
                ["Account Number", input.accountNumber],
                ["Bank Name", input.bankName],
                ["Account Name", input.accountName],
                ["Payment rails", input.paymentRails || input.payment_rails],
                ["Branch name", input.branchName],
                ["Bank address", input.bankAddress],
                ["Bank code", input.bankCode],
                ["Routing number", input.routingNumber],
                ["IBAN", input.iban],
                ["Swift Code", input.swift],
            ];

            lines = ordered
                .map(([k, v]) => {
                    const vv = normalize(v);
                    if (!vv) return null;
                    return `${k}: ${vv}`;
                })
                .filter(Boolean);
        } else {
            lines = Object.entries(input)
                .map(([k, v]) => {
                    const vv = normalize(v);
                    if (!vv) return null;
                    return `${k}: ${vv}`;
                })
                .filter(Boolean);
        }
    }

    const text = lines.join("\n");
    const ok = await writeClipboard(text);

    toast(ok ? "All details copied!" : "Copy failed", ms, ok ? "success" : "error");
    return ok;
};
